import DOMPurify from 'dompurify';

export const sanitizeHTML = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code',
      'img', 'figure', 'figcaption', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'div', 'span', 'section', 'article', 'header', 'footer', 'nav',
      'style', 'hr', 'sup', 'sub', 'small', 'mark', 'del', 'ins',
      'video', 'source', 'iframe',
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'src', 'alt', 'title', 'class', 'id', 'style',
      'width', 'height', 'colspan', 'rowspan', 'data-*', 'loading',
      'controls', 'autoplay', 'loop', 'muted', 'type', 'allowfullscreen',
      'frameborder', 'allow',
    ],
    ALLOW_DATA_ATTR: true,
  });
};
